import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home";
import Story from "./pages/Story";
import Gallery from "./pages/Gallery";
import Message from "./pages/Message";
import Gift from "./pages/Gift";
import Navbar from "./components/Navbar";
import ConfettiLayer from "./components/Confettilayer";
import FloatingHearts from "./components/FloatingHearts";
import { MusicProvider } from "./context/MusicContext";

function App() {
  const [showNavbar, setShowNavbar] = useState(true);

  const handleBeginJourney = () => {
    setShowNavbar(false);
  };

  return (
    <MusicProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-gradient-to-br from-pink-100 via-rose-100 to-purple-100 font-poppins relative overflow-x-hidden">
          <ConfettiLayer />
          <FloatingHearts />
          <Routes>
            <Route path="/" element={<Home onBeginJourney={handleBeginJourney} />} />
            <Route path="/story" element={<Story />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/message" element={<Message />} />
            <Route path="/gift" element={<Gift />} />
          </Routes>
        </div>
      </BrowserRouter>
    </MusicProvider>
  );
}

export default App;
